app.service('deliveryView', function (console, deliveryPoints, orderConfig, agreementsSubmit,
	orderUtils, modal, broker, loading, html, deliveryInputs, deliveryLocation, validate, emailInvalid, front, cartRetrieve,
	permissions, unavailableItemsModal, deliveryBuyerDetails, deliveryInvoiceDetails,
	deliveryAdditionalEntityInvoiceDetails, deliveryHomeAddressDetails, deliveryReceiverDetails, deliveryAddressDetails,
	deliveryUserInfoDetails) {

	let $self, $form, $phone, $deliverySelect, $receiverSelect, $invoiceSelect,
		$operatorClientEmail, $operatorClientEmailRow, $next;
	let initConfig;

	let config;
	let isOneInit = false;

	function switchDeliveryAddress(value) {
		if (value) {
			console.log('ADRES DOSTAWY TAKI SAM');
			config.deliveryInfo.deliveryEqualsHome = true;

		} else {
			console.log('ADRES DOSTAWY INNY');
			config.deliveryInfo.deliveryEqualsHome = false;
		}
		$('input[type=checkbox].js-delivery-home-checkbox', $self).prop('checked', !config.deliveryInfo.deliveryEqualsHome);
		checkIgnoreInput();
	}
	function switchReceiverData(value) {

		if (value) {
			console.log('DANE ODBIORC - inne');
			config.deliveryInfo.sameReceiver = false;
		} else {
			console.log('DANE ODBIORCY - takie same');
			config.deliveryInfo.sameReceiver = true;

		}
		checkIgnoreInput();
	}
	function switchReservation(value) {
		if (value === 'true' && config.deliveryInfo.forceReservation === false) {
			console.log('CHCĘ REZERWACJĘ');
			config.deliveryInfo.forceReservation = true;

			if (initConfig.deliveryInfo.frontUserType !== config.deliveryInfo.frontUserType) {
				console.log('Wymuszenie typu klienta: ' + initConfig.deliveryInfo.frontUserType);
				//potrzeba przywrócenia danych inicjalnych bloczków które teraz zostały ukryte
				if (initConfig.deliveryInfo.frontUserType == 'INDIVIDUAL') {
					$('#individual').trigger('click');
					//$('#pesel').val(initConfig.savedData.pesel);
				} else {
					$('#company').trigger('click');
					//$('#nip').val(initConfig.savedData.nip);
					//$('#company-name-textarea').val(initConfig.savedData.companyName);
				}
			}
			config.deliveryInfo.invoiceNeeded = true;

			changeTextNextButton(true);
		} else if (value === 'false' && config.deliveryInfo.forceReservation === true) {
			console.log('NIE CHCĘ REZERWACJI');
			config.deliveryInfo.forceReservation = false;
			changeTextNextButton(false);
		}
		checkIgnoreInput();
		$('input[type=checkbox].js-toggle-reservation-data-checkbox', $self).prop('checked', config.deliveryInfo.forceReservation);
		deliveryInputs.checkReservation(config.deliveryInfo.forceReservation);
	}

	function changeTextNextButton(value) {
		const ariaLabel = value ? config.shortOrderNextButtonAriaLabel : config.nextButtonAriaLabel;
		const text = value ? config.shortOrderNextButtonText : config.nextButtonText;
		$next.html(text);
		if (ariaLabel.length) {
			$next.attr('aria-label', ariaLabel);
		} else {
			$next.removeAttr('aria-label');
		}
	}
	function switchTaxFree(value) {
		if (value === 'true' && config.deliveryInfo.taxfree === false) {
			console.log('CHCĘ TAXFREE');
			config.deliveryInfo.taxfree = true;
			config.deliveryInfo.invoiceNeeded = false;
		} else if (value === 'false' && config.deliveryInfo.taxfree === true) {
			console.log('NIE CHCĘ TAXFREE');
			config.deliveryInfo.taxfree = false;
		}
		if (config.deliveryInfo.reserveAndCollectOnlyInStoreMode) {
			changeTextNextButton(config.deliveryInfo.taxfree);
		}
		$('#preview-order-steps .row-delivery-point').hide();
		$self.removeClass('hide-shops');
		if (html.has('points-on-modal')) {
			deliveryPoints.checkTaxFree();
		} else {
			deliveryLocation.refresh();
		}
		$self.toggleClass('taxfree-enabled', config.deliveryInfo.taxfree);
		$('input[type=checkbox].js-toggle-taxfree-data-checkbox', $self).prop('checked',config.deliveryInfo.taxfree);
		$('#home-address-details input').ignore(config.deliveryInfo.taxfree && !config.deliveryInfo.withWarranty);
		checkIgnoreInput();
	}
	function switchProductWithCouponAvailable(value) {
		if (value === 'true' && config.deliveryInfo.productWithCoupon === false) {
			config.deliveryInfo.productWithCoupon = true;
			config.deliveryInfo.invoiceNeeded = false;
			console.log('CHCĘ BON');
			changeTextNextButton(true);
		} else if (value === 'false' && config.deliveryInfo.productWithCoupon === true) {
			config.deliveryInfo.productWithCoupon = false;
			console.log('NIE CHCĘ BONU');
			changeTextNextButton(false);
		}
		$self.toggleClass('product-with-coupon-enabled', config.deliveryInfo.productWithCoupon);
		checkIgnoreInput();
	}
	function checkIgnoreInput() {
		deliveryBuyerDetails.render();
		deliveryReceiverDetails.render();
		deliveryInvoiceDetails.render();
		deliveryAdditionalEntityInvoiceDetails.render();
		deliveryAddressDetails.render();
	}
	function copyPassword(password) {
		$('#password2').val(password);
	}
	function copyDeliveryAddress(i) {
		console.log('KOPIOWANIE DANYCH DO DOSTAWY');
		var address = config.deliveryAddresses[i];
		deliveryInputs.deliveryAddressSwitch(address);
		if (i != "0") {
			$('#delivery-address input').checkValid();
		}
	}
	function copyReceiverData(id) {
		console.log('KOPIOWANIE DANYCH ODBIORCY');
		var receiverData;

		if (id === "0") {
			receiverData = config.receiverDatas[0];
		} else {
			receiverData = config.receiverDatas.find(function (data) {
				return data.id === id;
			});
		}

		if (receiverData) {
			deliveryInputs.receiverDataSwitch(receiverData);
			if (id !== "0") {
				$('#receiver-data input').checkValid();
			}
		} else {
			console.log('Nie znaleziono danych odbiorcy o podanym id: ' + id);
		}
	}
	function copyInvoiceData(id) {
		console.log('KOPIOWANIE DANYCH DO FAKTURY - NABYWCA');
		const address = getInvoiceAddress(id);
		deliveryInvoiceDetails.switchAddress(address);
		if (id !== "0") {
			$('input[name^=invoice]').checkValid();
		}
	}
	function getInvoiceAddress(id) {
		if (id === "0") {
			return config.invoiceAddresses[0];
		} else {
			return config.invoiceAddresses.find(data => data.id === id);
		}
	}
	function next() {
		console.log('DALEJ NA 3 KROKU');
		if (html.has('points-on-modal') && config.deliveryType == 'shop' && config.shopCode && config.deliveryInfo.taxfree && !config.taxfreeAvailable) {
			modal.alert('Wybierz sklep, w którym chcesz odebrać zamówienie. W obecnie wybranym sklepie nie ma możliwości realizacji Tax Free.');
			return;
		}
		if (unavailableItemsModal.checkStatus()) {
			return;
		}
		deliveryInputs.validate(config);
	}
	function back() {
		orderUtils.back();
	}

	function setElements() {
		config = orderConfig.getData();
		initConfig = JSON.parse(JSON.stringify(orderConfig.getData()));
		$self = $('#container');
		if (!($self && $self.length)) {
			console.log('błąd generowania strony', config)
		}
		$form = $('#choose-delivery-form', $self);
		$phone = $('#phone', $self);
		$deliverySelect = $('#delivery-select', $self);
		$receiverSelect = $('#receiver-select', $self);
		$invoiceSelect = $('#invoice-select', $self);
		$paperInvoiceStatus = $('#paper-invoice-status', $self);
		$operatorClientEmail = $('#e-mail', $self);
		$operatorClientEmailRow = $('#e-mail-row', $self);
		$next = $('.js-delivery-next', $self);
	}

	function setEvents() {
		$self.on('click', '.js-delivery-next', function () {
			next();
		}).on('click', '.js-delivery-back', function () {
			if (html.has('new-delivery')) {
				loading.redirect({
					href: '/cart-delivery.bhtml',
					soft: true
				});
			} else {
				back();
			}
		});
		$('#order-version-change .js-order-version-change').on('click', function (event) {
			event.preventDefault();
			event.stopPropagation();
			const testName = config.orderFeaturesTestName;
			if (testAB.getVar(testName) === 'B') {
				testAB.setVar(testName, 'A');
			} else {
				testAB.setVar(testName, 'B');
			}
			loading.redirect(document.location.pathname);
		});

		emailInvalid.init($operatorClientEmail, $('#email-invalid-text'), $operatorClientEmailRow);

		$('#password', $self).on('focusout', function () {
			copyPassword($(this).val());
		});
		$('input[type=checkbox].js-delivery-home-checkbox', $self).on('click', function () {
			$('input[type=radio].js-delivery-home[value=' + !$(this).prop('checked') + ']', $self).trigger('click');
		});
		$('input[type=radio].js-delivery-home', $self).on('click', function () {
			switchDeliveryAddress($(this).val() === "true");
		});
		//przełączanie danych odbiorcy innych niż użytkownika
		$('input[type=checkbox].js-switch-receiver-data-checkbox', $self).on('click', function () {
			$('input[type=radio].js-switch-receiver-data[value=' + $(this).prop('checked') + ']', $self).trigger('click');
		});
		$('input[type=radio].js-switch-receiver-data', $self).on('click', function () {
			switchReceiverData($(this).val() === "true");
		});
		$('input[type=checkbox].js-toggle-taxfree-data-checkbox', $self).on('click', function () {
			$('input[type=radio].js-taxfree-needed[value=' + $(this).prop('checked') + ']', $self).trigger('click');
		});
		$('input[type=radio].js-taxfree-needed', $self).on('click', function () {
			switchTaxFree($(this).val());
		});
		$('input[type=checkbox].js-toggle-reservation-data-checkbox', $self).on('click', function () {
			$('input[type=radio].js-reservation-needed[value=' + $(this).prop('checked') + ']', $self).trigger('click');
		});
		$('input[type=radio].js-reservation-needed', $self).on('click', function () {
			switchReservation($(this).val());
		});
		$('input[type=radio].js-product-with-coupon', $self).on('click', function () {
			switchProductWithCouponAvailable($(this).val());
		});
		//wybór danych w selekcie adresów dostawy
		$deliverySelect.on('change', function () {
			copyDeliveryAddress($(this).val());
		});
		//wybór danych w selekcie danych odbiorcy
		$receiverSelect.on('change', function () {
			copyReceiverData($(this).val());
			deliveryReceiverDetails.setPolishPhonePrefixForReceiver();
		});
		//wybór danych w selekcie danych do faktury
		$invoiceSelect.on('change', function () {
			copyInvoiceData($(this).val());
		});

		$self.on('click', '#company', function () {
			config.deliveryInfo.frontUserType = "COMPANY";
			checkIgnoreInput();
			broker.trigger('DELIVERY_FRONT_USER_TYPE_CHANGED');
		});
		$self.on('click', '#individual', function () {
			config.deliveryInfo.frontUserType = "INDIVIDUAL";
			config.deliveryInfo.showAdditionalInvoice = false;

			if ($('input[name=toggle-invoice-data]:checked').val() === 'true') { // jeśli zaznaczono "Inne dane do faktury"
				config.deliveryInfo.invoiceNeeded = true;
			}
			checkIgnoreInput();
			broker.trigger('DELIVERY_FRONT_USER_TYPE_CHANGED');
		});

		//Jesli uzytkownik jest zalogowany i zmieni dane przy wyborze sklepu, pokaz komunikat(zgode) o przetwarzaniu danych
		$self.on('change', 'input:not([type="checkbox"])', function () {
			$self.removeClass('hide-permissions-desc');
		})

		if ($deliverySelect.length) {
			copyDeliveryAddress($deliverySelect.val());
		}

		if ($receiverSelect.length && !config.deliveryInfo.foreignReceiverPhone) {
			copyReceiverData($receiverSelect.val());
		}

		$('#permissions-list.old-mode input').click(function () {
			permissions.updateOldAgreements();
		});

		$('#phone-country-code-selector').on('change', function () {
			validate.element($(this), $form);

			if ($phone.val().length) {
				validate.element($phone, $form);
			}
			if (config.deliveryInfo.isCellPhoneRequired) {
				deliveryReceiverDetails.setForeignReceiverPhone($(this).val());
				switchReceiverData($(this).val() !== '+48');
			}
			if (hasChangedPolishPhonePrefix($(this))) {
				if ($phone.val().length) {
					$phone.val('');
					validate.element($phone, $form);
				}
			}
			$(this).data('prev-value', $(this).val());
		});

		$phone.phoneFormat();

		if (!isOneInit) {
			isOneInit = true;
			broker.on('ORDER-NEXT-STEP', function () {
				if ($('.js-delivery-next').length && orderConfig.getData().pageType == 'delivery') {
					next();
				}
			});
			broker.on('PREVIEW_REFRESH', function () {
				if (front.page() === 'shop-delivery' || front.page() === 'home-delivery') {
					$next = $('.js-delivery-next', $self);
					changeTextNextButton(config.deliveryInfo.forceReservation || config.deliveryInfo.productWithCoupon || (config.deliveryInfo.reserveAndCollectOnlyInStoreMode && config.deliveryInfo.taxfree));
				}
			});
		}
	}

	function hasChangedPolishPhonePrefix($prefix) {
		const previousValue = $prefix.data('prev-value');
		const currentValue = $prefix.val();

		if (previousValue === '+48' && currentValue !== '+48') {
			return true;
		}

		return previousValue !== '+48' && currentValue === '+48';
	}

	function initDeliveryLocation() {
		var selectLocationCallback = function (params) {
			$next.removeClass('btn-disabled');
			if (config.deliveryType == 'shop' && params && params.lastLocation && params.shopCode && params.cityCode) {
				config.shopCode = params.shopCode;
				config.cityCode = params.cityCode;
			}
			$('.js-k3-other-delivery-time', $self).on('click', function () {
				const checked = $(this).is(':checked');
				const text = checked ? 'Dalej' : config.nextButtonText;
				$next.text(text);
				$('.js-k3-other-delivery-time', $self).prop('checked', checked);
				$('#other-delivery-time-selection').val(checked);
			});
		};
		switch (config.deliveryType) {
			case 'shop':
				if (html.has('points-on-modal')) {
					$('#shops-list, #short-delivery-address-data').remove();
					deliveryPoints.init(selectLocationCallback);
				} else {
					$('#new-delivery-points, #delivery-points, #modal-delivery-points').remove();
					$next.addClass('btn-disabled');
					deliveryLocation.init({
						deliveryType: config.deliveryType
					},
						selectLocationCallback
					);
				}
				break;
			case 'inpost':
			case 'pickupPoint':
				deliveryPoints.init(selectLocationCallback);
				break;
		}
	}

	function init() {
		setElements();
		deliveryInputs.init($self);
		validate.task('chooseDelivery', {
			deliveryType: config.deliveryType,
			emailRequiredValidationEnabled: config.emailRequiredValidationEnabled,
			isPolishAddressRequired: config.deliveryInfo.isPolishAddressRequired,
			isPolishReceiverPhoneNumberRequired: config.deliveryInfo.isPolishReceiverPhoneNumberRequired,
			isPolishCustomerPhoneNumberRequired: config.deliveryInfo.isPolishCustomerPhoneNumberRequired
		});

		if (config.deliveryInfo.productWithCoupon === true || config.deliveryInfo.forceReservation || (config.deliveryInfo.reserveAndCollectOnlyInStoreMode && config.deliveryInfo.taxfree)) {		// w wyniku walidacji formularza po odświeżeniu prawa strona pokazuje "dalej" a w rzeczywistości powinno być "rezerwuję". Z racji że to osobny url to nie można tego osiągnąć w backendzie
			changeTextNextButton(true);
		}

		deliveryUserInfoDetails.init($form);
		deliveryBuyerDetails.init($form);
		deliveryReceiverDetails.init($form);
		deliveryAddressDetails.init();
		deliveryInvoiceDetails.init($form);
		deliveryAdditionalEntityInvoiceDetails.init($form);
		deliveryHomeAddressDetails.init($form, forceHomeDelivery => {
			switchDeliveryAddress(forceHomeDelivery);
		});
		setEvents();
		permissions.init();
		initDeliveryLocation();
		agreementsSubmit.init($form, $('#current-permissions input:checkbox'));
		unavailableItemsModal.init();
		if (config.validateMessage && config.validateMessage.length) {
			modal.alert(config.validateMessage);
		}
		if (!front.getParam('ajaxOrder') || testAB.getVar('ajax-order2') !== 'B') {
			if (location.hash == '#edit-point') {
				$('#short-delivery-address-data .js-show-points').trigger('click');
			} else if (location.hash == '#edit-inpost') {
				$('#short-delivery-address-data .js-show-inpost').trigger('click');
			} else if (location.hash == '#edit-shop') {
				$(html.has('points-on-modal') ? '.body-delivery-type-new .js-show-shops' : '#short-delivery-address-data .js-show-shops').trigger('click');
			} else if (location.hash == '#edit-data') {
				$('.js-show-user-data').trigger('click');
			}
		}
		if (html.has('points-on-modal')) {
			if (config.deliveryType === 'pickupPoint' && config.pickupPointCode === '') {
				deliveryPoints.show();
			} else if (config.deliveryType === 'inpost' && config.parcelCode === '') {
				deliveryPoints.show();
			} else if (config.deliveryType === 'shop' && config.shopCode === '') {
				deliveryPoints.show();
			}
		}



	}

	return {
		init
	};
});
